import { render } from "./IconClose.vue?vue&type=template&id=62587252"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/bundle-builder/components/icon/IconClose.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62587252"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62587252', __exports__)) {
    api.reload('62587252', __exports__)
  }
  
  module.hot.accept("./IconClose.vue?vue&type=template&id=62587252", () => {
    api.rerender('62587252', render)
  })

}


export default __exports__